<template>
  <v-container
    class="px-8 pt-6 pb-10 mb-16"
    style="max-width: 500px; margin-right: auto; margin-left: auto"
  >
    <v-row no-gutters class="text-h4 font-weight-bold">
      <v-col align-self="center" class="main-font secondary--text"
        >Profile</v-col
      >
      <v-col cols="auto" align-self="center"> <Levels /></v-col>
    </v-row>
    <v-fade-transition>
      <v-row no-gutters v-if="!selfPending">
        <v-col>
          <v-row no-gutters class="mb-6 mx-2 mt-10" justify="center">
            <v-col cols="auto" style="position: relative">
              <v-img
                :src="profilePictureUrl"
                class="rounded-circle shrink white"
                width="100"
                height="100"
                transition="fade-transition"
                style="border: solid 1px #e0e0e0 !important"
                @click="
                  profilePictureUrl
                    ? $store.commit(
                        'fullScreenPicture/setUrl',
                        profilePictureUrl
                      )
                    : null
                "
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-icon size="30" color="#e0e0e0"
                      >mdi-account-outline</v-icon
                    >
                  </v-row>
                </template>
              </v-img>
              <label
                for="file"
                class="pa-1 rounded-circle"
                style="
                  position: absolute;
                  bottom: 0px;
                  right: 0px;
                  background-color: white;
                  border: solid 1px #e0e0e0 !important;
                "
              >
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                  style="width: 24px; height: 24px"
                  v-if="selfUpdatePendings.includes('profilePictureUrl')"
                >
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    size="16"
                    width="3"
                  ></v-progress-circular
                ></v-row>
                <v-icon v-else color="primary">mdi-camera-outline</v-icon>
              </label>
              <input
                type="file"
                id="file"
                @change="onFileChange"
                accept="image/*"
                style="display: none"
              />
            </v-col>
          </v-row>

          <v-row no-gutters class="mb-8 mx-2" justify="center">
            <v-text-field
              label="Nickname"
              outlined
              color="primary"
              background-color="white"
              style="max-width: 200px"
              v-model.trim="nickname"
              rounded
              hide-details
              :loading="selfUpdatePendings.includes('nickname')"
              :disabled="selfUpdatePendings.includes('nickname')"
              @keyup.enter="save('nickname', nickname)"
              @blur="save('nickname', nickname)"
            ></v-text-field>
          </v-row>

          <v-row no-gutters class="mt-7" justify="center">
            <v-text-field
              label="E-mail"
              style="max-width: 200px"
              outlined
              color="primary"
              background-color="white"
              :value="email"
              hide-details
              disabled
              rounded
            ></v-text-field>
          </v-row>

          <v-row
            no-gutters
            class="text-h5 font-weight-bold mt-16 mb-4"
            v-if="toUpdate"
            ><span class="main-font secondary--text">Update</span></v-row
          ><v-badge
            v-if="toUpdate"
            top
            color="error"
            dot
            offset-x="10"
            offset-y="10"
            bordered
          >
            <v-btn
              @click="$store.dispatch('update/update')"
              depressed
              class="rounded-pill text-none"
              height="40"
              outlined
            >
              <v-icon size="20" class="mr-2" color="primary"
                >mdi-arrow-up-bold-outline</v-icon
              >
              New content available
            </v-btn></v-badge
          >

          <v-row
            no-gutters
            class="text-h5 font-weight-bold mt-12 mb-4"
            v-if="addToHomeScreen"
            ><span class="main-font">Add to home screen</span></v-row
          >
          <v-btn
            v-if="addToHomeScreen"
            @click="$store.dispatch('install/addToHomeScreen')"
            depressed
            class="rounded-pill text-none"
            height="40"
            outlined
          >
            <v-icon size="20" class="mr-2" color="primary"
              >mdi-cellphone-arrow-down</v-icon
            >
            Add to home screen
          </v-btn>

          <v-row no-gutters class="text-h5 font-weight-bold mt-12 mb-4"
            ><span class="main-font secondary--text">About</span></v-row
          >

          <v-row no-gutters>
            <v-btn
              class="text-none"
              rounded
              large
              depressed
              outlined
              to="/about"
              >Learn more about this app</v-btn
            >
          </v-row>

          <v-row no-gutters class="text-h5 font-weight-bold mt-12 mb-4"
            ><span class="main-font secondary--text">Account</span></v-row
          >

          <v-row no-gutters
            ><v-btn
              class="text-none transparent text-decoration-underline ml-n4"
              rounded
              large
              depressed
              @click="signOut()"
              >Sign out</v-btn
            ></v-row
          >
        </v-col>
      </v-row>
    </v-fade-transition>

    <v-row v-if="selfPending" justify="center" no-gutters class="mt-16">
      <Loader style="width: 200px; height: 200px" />
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import resizePicture from "@/utils/resizePicture.js";
import Levels from "@/components/profile/Levels.vue";

export default {
  name: "Profile",
  components: {
    Levels,
  },
  data: () => ({
    fullScreenPicture: false,
    fullScreenPictureUrl: "",
    nickname: "",
    email: undefined,
    phone: "",
    profilePictureUrl: null,
    pendings: [],
  }),
  watch: {
    self: {
      handler: function (val) {
        if (val) {
          this.nickname = val.nickname || "";
          this.email = val.email;
          this.phone = val.phone || "";
          if (this.profilePictureUrl === null && val.profilePictureUrl) {
            this.profilePictureUrl = val.profilePictureUrl;
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState("self", ["self", "selfPending", "selfUpdatePendings"]),
    ...mapState("install", ["addToHomeScreen"]),
    ...mapState("update", ["toUpdate"]),
  },
  beforeDestroy() {
    this.$store.commit("fullScreenPicture/setUrl", null);
  },
  methods: {
    handleResizePicture(e, size) {
      return resizePicture(e, size);
    },
    async onFileChange(e) {
      try {
        const dataurl = await resizePicture(e.target.files[0], 1000, 1000);
        this.profilePictureUrl = dataurl;

        this.$store.dispatch("level/updateLevel", {
          field: "profilePictureUrl",
          value: true,
        });
        this.$store.dispatch("self/uploadProfilePicture", dataurl);
      } catch (error) {
        console.log(error);
      }
    },
    async signOut() {
      this.$store.dispatch("auth/signOut");
    },
    async save(field, value) {
      if (value === "") return;
      this.$store.dispatch("level/updateLevel", {
        field: "nickname",
        value: true,
      });
      await this.$store.dispatch(`self/updateSelf`, { field, value });
      this.$store.commit(`snackbar/setSnackbar`, {
        color: "primary",
        timeout: 3000,
        text: "Modification saved",
      });
    },
  },
};
</script>

<style >
.v-badge__badge {
  width: 12px !important;
  height: 12px !important;
}
</style>
